/**
 * LocationsManager actions.
 * @module actions/locationsManager
 */
export const GET_LOCATIONS_MANAGER = 'GET_LOCATIONS_MANAGER';

/**
 * Get locationsManager.
 * @function getLocationsManager
 * @returns {Object} Get locationsManager action.
 */
export function getLocationsManager(path) {
  return {
    type: GET_LOCATIONS_MANAGER,
    request: {
      op: 'get',
      path: `${path}/@locations-manager`,
    },
  };
}
